import { useMemo } from 'react';

import { useQuests } from '@/hooks/useQuests';
import { useTelegramBotQuest } from '@/hooks/useTelegramBotQuest';
import { mergeSyntheticOnboardingQuest } from '@/lib/adapters';
import { applyBonusBotGate, applyOnboardingSequence } from '@/lib/questSequence';
import type { QuestSection } from '@/lib/types';

/**
 * The quest catalogue as every mission surface should see it: `useQuests()`
 * plus the client-synthesized "Connect Telegram Bot" card, with the strict
 * onboarding order applied (see `applyOnboardingSequence`) and bonus quests
 * gated on the bot link (see `applyBonusBotGate`). The Missions page, the
 * quest modal and the totals all read this so they never disagree about
 * what's locked.
 */
export function useMissionSections() {
  const query = useQuests();
  const telegramBotQuest = useTelegramBotQuest();

  const data = useMemo<QuestSection[] | undefined>(
    () =>
      query.data
        ? applyBonusBotGate(
            applyOnboardingSequence(mergeSyntheticOnboardingQuest(query.data, telegramBotQuest)),
          )
        : query.data,
    [query.data, telegramBotQuest],
  );

  return { ...query, data };
}
